import { io } from 'socket.io-client';

import { API_URL } from './config/envVars';
import getLyocCookie from './Cookies';

export const socket = io(API_URL || '', {
	autoConnect: false,
	extraHeaders: {
		authorization: `bearer ${getLyocCookie()}`,
	},
});

// export function getLobbyId(gameId: string | null = ''){
// 	return `lobby:${gameId}`;
// }

// export function getGameId(gameId: string | null = ''){
// 	return `game:${gameId}`
// }
